import styled from "styled-components";

export const PaginationContainer = styled.ul`
  display: flex;
  list-style-type: none;
  justify-content: flex-end;

  @media (max-width: 768px) {
    padding-left: 0;
  }
`;

export const PaginationItem = styled.li`
  width: 40px;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #d1d1d1;
  border-left-width: 1px;
  border-right-width: 1px;
  color: rgb(132, 132, 132);
  font-weight: bold;
  font-size: 12px;
  letter-spacing: 0.12px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  &:first-of-type {
    border-radius: 5px 0px 0px 5px;
    border-left-width: 2px;
  }
  &:last-of-type {
    border-radius: 0px 5px 5px 0px;
    border-right-width: 2px;
  }
  &.dots:hover {
    background-color: transparent;
    cursor: default;
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
    cursor: pointer;
  }
  &.selected {
    background-color: ${(props) => props?.tema?.primaryColor}33;
    border-color: ${(props) => props?.tema?.primaryColor};
    border-width: 2px;
    color: ${(props) => props?.tema?.primaryColor};
  }
  &.disabled {
    pointer-events: none;

    svg {
      fill: #d1d1d1;
    }
    &:hover {
      background-color: transparent;
      cursor: default;
    }
  }
`;
